import { render, staticRenderFns } from "./ModalExamples.vue?vue&type=template&id=15070b3e"
import script from "./ModalExamples.vue?vue&type=script&lang=js"
export * from "./ModalExamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports